export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/islamic.b9523182.gif","height":450,"width":450,"blurWidth":0,"blurHeight":0};